import React from 'react';
import { LeadForm } from './LeadForm';
import { Star } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-navy pt-12 pb-20 lg:pt-20 lg:pb-28 overflow-hidden" data-id="element-140">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-141">
        <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=2000&auto=format&fit=crop" alt="Large yellow excavator secured on a heavy haul transport trailer" className="w-full h-full object-cover opacity-40" data-id="element-142" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/95 to-brand-navy/70 mix-blend-multiply" data-id="element-143"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-145">
          {/* Hero Content */}
          <div className="text-white space-y-6" data-id="element-146">
            <div className="flex flex-wrap gap-3" data-id="element-147">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-red border border-brand-red text-sm font-bold shadow-sm" data-id="element-148">
                We Set The Standard in Heavy Haul
              </div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-sm font-semibold backdrop-blur-sm" data-id="element-149">
                <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-150" />
                Top-Rated Heavy Equipment Haulers
              </div>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight text-balance" data-id="element-151">
              The Expert Oversize Load & Heavy Equipment Shippers
            </h1>

            <p className="text-lg md:text-xl text-slate-200 text-balance max-w-xl" data-id="element-152">
              Experience quality heavy load transport services. Quick. Reliable.
              Hassle-Free. Deal direct with a licensed, insured carrier — one
              quote, one company, one call.
            </p>

            <div className="flex flex-col gap-2 pt-4" data-id="element-153">
              <a href="tel:+17543251100" className="inline-flex items-center justify-center gap-3 bg-white text-brand-navy hover:bg-slate-100 font-bold py-3.5 px-6 rounded-full shadow-lg transition-all border-2 border-transparent hover:border-brand-red w-fit" data-id="element-154">
                <div className="bg-brand-red p-2 rounded-full" data-id="element-155">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-156">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-157" />
                  </svg>
                </div>
                <span className="text-lg" data-id="element-158">(754) 325-1100</span>
              </a>
              <div className="flex items-center gap-2 text-sm text-slate-300 ml-2" data-id="element-159">
                <span className="relative flex h-2.5 w-2.5" data-id="element-160">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-red opacity-75" data-id="element-161"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-red" data-id="element-162"></span>
                </span>
                Speak with a live transport expert now
              </div>
            </div>
          </div>

          {/* Hero Form */}
          <div className="w-full max-w-md mx-auto lg:max-w-none lg:ml-auto" data-id="element-163">
            <LeadForm data-id="element-164" />
          </div>
        </div>
      </div>
    </section>;
}